import { topics } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto">
            当前最受关注的网红黑料话题标签，热度实时更新，点击查看相关内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="group inline-flex items-center gap-2 px-4 py-2.5 md:px-5 md:py-3 rounded-xl border transition-all duration-300 cursor-pointer no-underline"
              style={{
                borderColor: i < 3 ? 'oklch(0.52 0.21 20 / 0.4)' : 'oklch(0.88 0.02 85 / 0.7)',
                backgroundColor: i < 3 ? 'oklch(0.52 0.21 20 / 0.06)' : 'oklch(0.97 0.01 85 / 0.8)',
              }}
            >
              <span className="text-xs md:text-sm font-semibold text-foreground-800 font-heading whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs font-medium font-label whitespace-nowrap">{topic.heat}</span>
              <span className="text-xs text-foreground-400 font-label hidden sm:inline">
                {topic.count.toLocaleString()}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}